module.exports = __webpack_public_path__ + "img/background-gold-large.1243f47d.svg";